const veeValidateLocale = {
  veeValidate: {
    code: "fr",
    messages: {
      _default: "Le champ est invalide",
      alpha: "Le champ ne peut contenir que des lettres",
      alpha_num: "Le champ ne peut contenir que des caractères alpha-numériques",
      alpha_dash: "Le champ ne peut contenir que des caractères alpha-numériques, tirets ou soulignés",
      alpha_spaces: "Le champ ne peut contenir que des lettres ou des espaces",
      between: "Le champ doit être compris entre {min} et {max}",
      confirmed: "Le champ ne correspond pas",
      digits: "Le champ doit être un nombre entier de {length} chiffres",
      dimensions: "Le champ doit avoir une taille de {width} pixels par {height} pixels",
      email: "Le champ doit être une adresse e-mail valide",
      not_one_of: "Le champ doit être une valeur valide",
      ext: "Le champ doit être un fichier valide",
      image: "Le champ doit être une image",
      integer: "Le champ doit être un entier",
      length: "Le champ doit contenir {length} caractères",
      max_value: "Le champ doit avoir une valeur de {max} ou moins",
      max: "Le champ ne peut pas contenir plus de {length} caractères",
      mimes: "Le champ doit avoir un type MIME valide",
      min_value: "Le champ doit avoir une valeur de {min} ou plus",
      min: "Le champ doit contenir au minimum {length} caractères",
      numeric: "Le champ ne peut contenir que des chiffres",
      one_of: "Le champ doit être une valeur valide",
      one_of_values: "Le champ doit être une valeur valide ({values})",
      not_one_of_values: "Le champ ne doit pas être l'une des valeurs suivantes: {values}",
      regex: "Le champ est invalide",
      required: "Le champ est obligatoire",
      required_if: "Le champ est obligatoire lorsque {target} possède cette valeur",
      size: "Le champ doit avoir un poids inférieur à {size}KB",
      url: "Le champ n'est pas une URL valide",
      nameConjunction: "Merci de ne saisir les coordonnées que d’une seule personne",
    },
  },
};

export type VeeValidateLocale = typeof veeValidateLocale;
export default veeValidateLocale;
